import { FormControl, FormField } from '@/components/ui/Form';
import { Form, FormItem, IconFa } from '@/components/wm';
import { zodResolver } from '@hookform/resolvers/zod';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export function NewWidgetType ({ data, onChangeField, onCompleted }) {
    const formSchema = z.object({
        type: z.string().min(1, i18next.t('form_validations.widget_type.type_required'))
    });

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            type: data.type || ''
        },
        mode: 'onChange'
    });

    useEffect(() => {
        onCompleted(form.formState.isValid);
    }, [form.formState.isValid]);

    return (
        <Form {...form} className="!tw-max-w-full !tw-max-h-1/4">
            <FormField
                control={form.control}
                name="type"
                render={({ field }) => (
                    <FormItem>
                        <FormControl>
                            <div className="tw-grid tw-grid-cols-3 tw-grid-rows-2 tw-gap-4">
                                <div
                                    className={`group tw-relative tw-gap-1 tw-rounded-sm tw-border tw-bg-primary tw-text-secondary
                                                        tw-min-w-full tw-flex tw-flex-col tw-justify-between tw-overflow-hidden tw-max-h-full
                                                        tw-p-4 tw-h-[200px] tw-cursor-pointer tw-transition tw-duration-200
                                                        ${data.type === 'value_card' ? 'tw-opacity-100' : 'tw-opacity-75 hover:tw-opacity-100'}`}
                                    onClick={() => {
                                        field.onChange('value_card');
                                        onChangeField('type')('value_card');
                                    }}
                                >
                                    {/* Content */}
                                    <div className="tw-relative tw-z-10 tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-between">
                                        <div className="tw-flex tw-items-center tw-justify-between">
                                            <div className="tw-text-sm tw-font-medium">{i18next.t('dashboard.custom_dashboard.value_card')}</div>
                                            <IconFa color="tw-text-secondary" icon="info" size="medium"/>
                                        </div>
                                        <div className="tw-flex tw-flex-col tw-items-end">
                                            <div className="tw-font-bold tw-text-3xl">{i18next.t('dashboard.custom_dashboard.value_placeholder')}</div>
                                            <div className="tw-text-xs tw-font-medium tw-text-right">{i18next.t('dashboard.custom_dashboard.legend_placeholder')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tw-bg-gray-100 tw-p-4 tw-rounded-sm tw-border">{i18next.t('dashboard.custom_dashboard.coming_soon')}</div>
                                <div className="tw-bg-gray-100 tw-p-4 tw-rounded-sm tw-border">{i18next.t('dashboard.custom_dashboard.coming_soon')}</div>
                                <div className="tw-bg-gray-100 tw-p-4 tw-rounded-sm tw-border">{i18next.t('dashboard.custom_dashboard.coming_soon')}</div>
                                <div className="tw-bg-gray-100 tw-p-4 tw-rounded-sm tw-border">{i18next.t('dashboard.custom_dashboard.coming_soon')}</div>
                                <div className="tw-bg-gray-100 tw-p-4 tw-rounded-sm tw-border">{i18next.t('dashboard.custom_dashboard.coming_soon')}</div>
                            </div>
                        </FormControl>
                    </FormItem>
                )}
            />
        </Form>
    );
}
